export const Routes = {
  DashboardOverview: { path: "/" },

  // MAIN SERVICES
  POSSystemPage: { path: "/services/pos" },
  WebDesignPage: { path: "/services/webdesign" },
  WebHostingPage: { path: "/services/webhosting" },

  // POS SUB-PAGES
  POSRetail: { path: "/services/POS/retail" },
  POSSupermarket: { path: "/services/POS/supermarket" },
  POSWines: { path: "/services/POS/wines" },
  POSRestaurant: { path: "/services/POS/restaurant" },
};